import { io, Socket } from 'socket.io-client';
import { SOCKET_CONFIG, SOCKET_URL } from './Sockets.constants';
import { tSocketManager } from './Sockets.types';

export const socket: Socket = io(SOCKET_URL, SOCKET_CONFIG);

export const socketManager: tSocketManager = {
    instance: socket,
    connect: () => {
        if (!socket.connected) socket.connect()
    },
    disconnect: () => {
        if (socket.connected) socket.disconnect()
    },
};
